export default __webpack_public_path__ + "static/media/Vacuna-para-todos-blanco.a775bbc1.png";